import { withInstall } from '../../../utils/with-install'
import Loca from './Loca.vue'

export const ElAmapLoca = withInstall(Loca)
export default ElAmapLoca
